export const GB = 'GB';
export const MB = 'MB';

export type DataSizeValue = typeof GB | typeof MB;
